import React from 'react';
import styles from './Licenses.module.css';
import { useNavigate } from 'react-router-dom';

function Licenses() {
  const navigate = useNavigate();
  const handleOrderClick = () => {
    navigate('/cart');
  };
  return (
    <section id="licenses" className={styles.licenses}>
      <div className={styles.banner}>
        <div className={styles.wave}>
          <svg viewBox="0 0 1440 280" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#F3F3FB"
              d="M0,252L40,242.7C80,233,160,215,240,177.3C320,140,400,84,480,93.3C560,103,640,177,720,177.3C800,177,880,103,960,93.3C1040,84,1120,140,1200,172.7C1280,205,1360,215,1440,182C1520,149,1600,75,1680,65.3C1760,56,1840,112,1920,116.7C2000,121,2080,75,2160,65.3C2240,56,2320,84,2400,121.3C2480,159,2560,205,2640,196C2720,187,2800,121,2880,88.7C2960,56,3040,56,3120,46.7C3200,37,3280,19,3360,14C3440,9,3520,19,3600,60.7C3680,103,3760,177,3840,191.3C3920,205,4000,159,4080,158.7C4160,159,4240,205,4320,191.3C4400,177,4480,103,4560,102.7C4640,103,4720,177,4800,191.3C4880,205,4960,159,5040,154C5120,149,5200,187,5280,182C5360,177,5440,131,5520,107.3C5600,84,5680,84,5720,84L5760,84L5760,280L5720,280C5680,280,5600,280,5520,280C5440,280,5360,280,5280,280C5200,280,5120,280,5040,280C4960,280,4880,280,4800,280C4720,280,4640,280,4560,280C4480,280,4400,280,4320,280C4240,280,4160,280,4080,280C4000,280,3920,280,3840,280C3760,280,3680,280,3600,280C3520,280,3440,280,3360,280C3280,280,3200,280,3120,280C3040,280,2960,280,2880,280C2800,280,2720,280,2640,280C2560,280,2480,280,2400,280C2320,280,2240,280,2160,280C2080,280,2000,280,1920,280C1840,280,1760,280,1680,280C1600,280,1520,280,1440,280C1360,280,1280,280,1200,280C1120,280,1040,280,960,280C880,280,800,280,720,280C640,280,560,280,480,280C400,280,320,280,240,280C160,280,80,280,40,280L0,280Z"
            />
          </svg>
        </div>
      </div>

      <h2 className={styles.sectionTitle}>Tilgjengelige lisenser</h2>
      <p className={styles.infoText}>Her er lisensene vi har å tilby. Vårt utvalg inkluderer løsninger som dekker ulike behov, fra grunnleggende til avanserte funksjoner, og passer både små bedrifter og større organisasjoner. Ta gjerne kontakt med oss for å finne den lisensen som best passer dine behov.</p>
      <div className={styles.licenseList}>
        <div className={styles.licenseCard}>
          <h3>KIPA</h3>
          <p>Vi har disse løsningene for deg som elev eller for deg som bedrift. KIPA er en digital løsning for alle notater og rapporter dine ansatte og du selv skal levere, for eksempel notater fra møter, utkast til møtereferat, befaringsrapporter, referat etter kundeoppfølging eller leverandørsamtaler.</p>
          <button onClick={handleOrderClick} className={styles.button}>Bestill</button>
        </div>
        <div className={styles.licenseCard}>
          <h3>KIPA-student</h3>
          <p>Vi har disse løsningene for deg som elev  KIPA student er en digital løsning for alle notater og rapporter du skal levere, for eksempel notater fra møter, utkast til møtereferat, befaringsrapporter, referat etter kundeoppfølging eller leverandørsamtaler.</p>
          <button onClick={handleOrderClick} className={styles.button}>Bestill</button>
        </div>
        <div className={styles.licenseCard}>
          <h3>AI-HR</h3>
          <p>AI-HR er en digital løsning for der firmaet ved hjelp av denne applikasjonen bruker kunstig intelligens (KI) til å følge opp ansatte.</p>
          <button onClick={handleOrderClick} className={styles.button}>Bestill</button>
        </div>
      </div>
    </section>
  );
}

export default Licenses;
